export const PRODUCT_SUITE_ITEM_COUNT = 4;

export type ProductSuiteState = {
  activeIndex: number;
  cycle: number;
};

export type ProductSuiteAction =
  { type: "advance"; itemCount: number } | { type: "select"; index: number };

export const initialProductSuiteState: ProductSuiteState = {
  activeIndex: 0,
  cycle: 0,
};

export function productSuiteReducer(
  state: ProductSuiteState,
  action: ProductSuiteAction,
): ProductSuiteState {
  switch (action.type) {
    case "advance":
      return {
        ...state,
        activeIndex: (state.activeIndex + 1) % action.itemCount,
        cycle: state.cycle + 1,
      };
    case "select":
      return {
        ...state,
        activeIndex: action.index,
        cycle: state.cycle + 1,
      };
  }
}
